<template>
  <div
    id="loading-bg"
    class="position-absolute position-left-0 position-right-0 position-bottom-0 position-top-0"
  >
    <div class="loading-logo">
      <img
        src="/logo.svg"
        :alt="$config.brand.name"
      >
    </div>
    <div class="loading">
      <div class="effect-1 effects" />
      <div class="effect-2 effects" />
      <div class="effect-3 effects" />
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */

import { NAME_FARMERS } from '@/router/routes/farmers'
import { NAME_NOW } from '@/router/routes/now'
import { Dialog } from '@capacitor/dialog'
// eslint-disable-next-line import/no-cycle
import { NAME_ROOT } from '@/router/routes/general'

export default {
  components: {},
  data() {
    return {}
  },
  computed: {},
  async mounted() {
    const maxRetries = 3
    let attempts = 0

    // eslint-disable-next-line consistent-return
    const loadApplication = async () => {
      try {
        if (!this.$store.getters['auth/isLogged']) {
          return this.$router.replace({ name: NAME_ROOT })
        }

        await this.$store.dispatch('auth/check')

        if (this.$store.getters['auth/getUser'] === null) {
          await this.$store.dispatch('auth/fetchUserProfile')
        }

        if (!this.$store.getters['farmers/isFetch']) {
          await this.$store.dispatch('farmers/fetch')
        }

        if (!this.$store.getters['farmers/isLoad']) {
          const success = await this.$store.dispatch('farmers/loadFarmer')
          if (!success) {
            return await this.$router.replace({ name: NAME_FARMERS })
          }
        }

        window.isReady = true
        await this.$router.replace({ name: NAME_NOW })
      } catch (error) {
        console.error('Erreur lors du chargement de l\'application :', error)

        attempts += 1
        if (attempts < maxRetries) {
          const retry = await Dialog.confirm({
            title: this.$t('pages.loading.error-retry.title'),
            message: this.$t('pages.loading.error-retry.message'),
            okButtonTitle: this.$t('pages.loading.error-retry.okButtonTitle'),
            cancelButtonTitle: this.$t('pages.loading.error-retry.cancelButtonTitle'),

          })

          if (retry.value) {
            return loadApplication()
          }
        }

        const disconnect = await Dialog.confirm({
          title: this.$t('pages.loading.persistent-error.title'),
          message: this.$t('pages.loading.persistent-error.message'),
          okButtonTitle: this.$t('pages.loading.persistent-error.okButtonTitle'),
          cancelButtonTitle: this.$t('pages.loading.persistent-error.cancelButtonTitle'),
        })

        if (disconnect.value) {
          const confirmDisconnect = await Dialog.confirm({
            title: this.$t('pages.loading.disconnect-confirmation.title'),
            message: this.$t('pages.loading.disconnect-confirmation.message'),
            okButtonTitle: this.$t('pages.loading.disconnect-confirmation.okButtonTitle'),
            cancelButtonTitle: this.$t('pages.loading.disconnect-confirmation.cancelButtonTitle'),
          })

          if (confirmDisconnect.value) {
            await this.$store.dispatch('auth/logout')
            await this.$router.replace({ name: NAME_ROOT })
          }
        }
      }
    }

    await loadApplication()
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/pages/page-misc.scss';
</style>
